module.exports = __webpack_public_path__ + "img/q_37_sor.9d72fe63.png";